export const REGISTRATION_EMAIL_USER_TYPES = [
  { type: 0, label: "Participantes" },
  { type: 1, label: "Usuários gestores" },
  { type: 2, label: "Expositores" },
];

const hasTemplateId = (value) => (
  value !== null && value !== undefined && value !== ""
);

const hasOwn = (value, key) => (
  value && Object.prototype.hasOwnProperty.call(value, key)
);

export const getRegisterTemplateReference = (register, userType) => {
  const typedTemplate = register?.templates?.[String(userType)];

  if (hasOwn(typedTemplate, "template_id")) {
    return {
      template_id: typedTemplate.template_id ?? null,
      template_version: typedTemplate.template_version ?? null,
    };
  }

  return {
    template_id: register?.template_id ?? null,
    template_version: register?.template_version ?? null,
  };
};

export const hasRegisterTemplateForType = (register, userType) => (
  hasTemplateId(getRegisterTemplateReference(register, userType).template_id)
);

export const getRegistrationTemplateUserTypes = (register, templateId) => (
  REGISTRATION_EMAIL_USER_TYPES.filter(({ type }) => hasTemplateId(templateId)
    && String(getRegisterTemplateReference(register, type).template_id) === String(templateId))
);

export const getMissingRegistrationTemplateTypes = (register, templates = []) => (
  REGISTRATION_EMAIL_USER_TYPES.filter(({ type }) => {
    const reference = getRegisterTemplateReference(register, type);
    return !hasTemplateId(reference.template_id) || reference.template_version == null
      || reference.template_version === "" || !Number.isFinite(Number(reference.template_version))
      || !templates.some((template) => String(template.template_id ?? template.value) === String(reference.template_id)
        && template.available !== false);
  })
);

export const normalizeRegisterTemplateConfiguration = (register = {}) => {
  const templates = { ...(register?.templates || {}) };

  REGISTRATION_EMAIL_USER_TYPES.forEach(({ type }) => {
    templates[String(type)] = getRegisterTemplateReference(register, type);
  });

  const participantTemplate = templates["0"];

  return {
    ...register,
    template_id: participantTemplate.template_id,
    template_version: participantTemplate.template_version,
    templates,
  };
};

export const isRegisterTemplateUsed = (register, templateId) => {
  if (!hasTemplateId(templateId)) return false;

  const references = [];
  if (hasTemplateId(register?.template_id)) {
    references.push(register.template_id);
  }

  Object.values(register?.templates || {}).forEach((template) => {
    if (hasTemplateId(template?.template_id)) {
      references.push(template.template_id);
    }
  });

  return references.some((reference) => String(reference) === String(templateId));
};

export const synchronizeRegisterTemplateVersion = (
  register,
  templateId,
  templateVersion,
) => {
  if (!register || !hasTemplateId(templateId)) {
    return { register, changed: false };
  }

  let changed = false;
  const templates = { ...(register.templates || {}) };
  const nextRegister = { ...register, templates };

  if (
    String(register.template_id) === String(templateId)
    && Number(register.template_version) !== Number(templateVersion)
  ) {
    nextRegister.template_version = templateVersion;
    changed = true;
  }

  Object.entries(templates).forEach(([type, template]) => {
    if (
      String(template?.template_id) === String(templateId)
      && Number(template?.template_version) !== Number(templateVersion)
    ) {
      nextRegister.templates[type] = {
        ...template,
        template_version: templateVersion,
      };
      changed = true;
    }
  });

  return { register: changed ? nextRegister : register, changed };
};
